//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'GlasgowOutcomeScale_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/Chart_GlasgowOutcomeScale_info.vue